import styled from 'styled-components';

/* ─── Drawer body ──────────────────────────────────── */

export const DrawerHeading = styled.p`
  font-size: var(--font-size\/heading-xs, 18px);
  font-family: 'Suisse Neue', sans-serif;
  font-weight: 500;
  line-height: var(--line-height\/heading-xs, 24px);
  letter-spacing: -0.72px;
  color: #1e1e29;
  margin: 0;
`;

export const DrawerSubDescription = styled.p`
  font-size: var(--font-size\/body-md, 15px);
  font-family: Lato, sans-serif;
  font-weight: 400;
  line-height: var(--line-height\/body-md, 20px);
  letter-spacing: 0.15px;
  color: #1e1e29;
  margin: 0;
`;

export const DrawerBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  padding: 20px 16px 16px;
  flex: 1;
  overflow-y: auto;
`;

export const DrawerOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const DrawerRequirements = styled.div`
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  gap: 1px;

  > p {
    font-size: var(--font-size\/body-md, 15px);
    font-family: Lato, sans-serif;
    font-weight: 400;
    line-height: var(--line-height\/body-md, 20px);
    letter-spacing: 0.15px;
    color: #1e1e29;
    margin: 0;
  }
`;

/* ─── Photo grid (inside drawer) ──────────────────── */

export const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
`;

export const Tile = styled.div`
  position: relative;
  height: 164px;
  border-radius: 8px;
  overflow: hidden;
  cursor: grab;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
  }
`;

export const DeleteButton = styled.button`
  position: absolute;
  top: 8px;
  left: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  background: #ffffff;
  box-shadow: 0 0 1px rgba(30, 30, 41, 0.16);
  color: #1e1e29;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
`;

export const TilePositionBadge = styled.span`
  position: absolute;
  top: 8px;
  right: 8px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: rgba(30, 30, 41, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  line-height: 21px;
  color: #ffffff;
  pointer-events: none;
`;

export const TileDragHandle = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #ffffff;
  box-shadow: 0 0 1px rgba(30, 30, 41, 0.16);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 8px;
  pointer-events: none;
`;

/* ─── Dropzone (add-more area inside drawer) ──────── */

export const Dropzone = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 167px;
  border: 1px dashed #bbbbbe;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  padding: 12px;
  gap: 12px;
  text-align: center;
  color: #1e1e29;
  font-size: var(--font-size\/body-md, 15px);
  font-family: Lato, sans-serif;
`;

/* ─── Empty trigger ────────────────────────────────── */

export const TriggerEmpty = styled.button`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 12px;
  gap: 12px;
  border: 1px solid #58585f;
  border-radius: 8px;
  background: #ffffff;
  cursor: pointer;
  font-size: var(--font-size\/body-md, 15px);
  font-family: Lato, sans-serif;
  color: #1e1e29;
`;

/* ─── Filled trigger ───────────────────────────────── */

export const TriggerFilled = styled.button`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 16px;
  gap: 12px;
  border: 1px solid #138900;
  border-radius: 12px;
  background: #ffffff;
  cursor: pointer;
  text-align: left;
`;

export const TriggerLabel = styled.span`
  font-size: var(--font-size\/body-sm, 12px);
  font-family: 'NOTHS Sans No3', sans-serif;
  font-weight: 600;
  letter-spacing: -0.12px;
  color: #1e1e29;
`;

export const TriggerFilledGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const TriggerFilledRow = styled.div`
  display: flex;
  gap: 10px;
  width: 100%;
  height: 160px;

  img {
    flex: 1;
    min-width: 0;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    display: block;
  }
`;

export const TriggerAddMoreTile = styled.span`
  flex: 1;
  min-width: 0;
  height: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border: 1px solid #cbc9c6;
  border-radius: 8px;
  font-size: var(--font-size\/body-md, 15px);
  font-family: Lato, sans-serif;
  color: #0e0e11;
  text-align: center;
  padding: 12px;
`;

export const TriggerMeta = styled.span`
  display: none;
`;

/* ─── Footer ───────────────────────────────────────── */

export const Footer = styled.div`
  display: flex;
  gap: 12px;
  padding: 20px 16px 16px;
  border-top: 1px solid #e9e9ea;
  background: #ffffff;
  flex-shrink: 0;
`;

export const FooterButton = styled.button<{ $variant: 'primary' | 'secondary' }>`
  height: 44px;
  padding: 12px 20px;
  border-radius: 400px;
  cursor: pointer;
  font-size: 15px;
  font-family: Lato, sans-serif;
  font-weight: 700;
  flex: ${({ $variant }) => ($variant === 'primary' ? '1' : '0 0 auto')};
  border: ${({ $variant }) => ($variant === 'secondary' ? '1px solid #b7b7b8' : 'none')};
  background: ${({ $variant }) => ($variant === 'primary' ? '#3a1945' : '#ffffff')};
  color: ${({ $variant }) => ($variant === 'primary' ? '#ffffff' : '#3a1945')};
  white-space: nowrap;

  &:disabled {
    cursor: not-allowed;
    opacity: 0.5;
  }
`;

/* ─── Status / error messages ──────────────────────── */

export const ErrorMessage = styled.p`
  color: #c0392b;
  font-size: 14px;
  margin: 8px 0 0;
`;

export const StatusMessage = styled.p`
  font-size: 14px;
  color: #666;
  margin: 8px 0 0;
`;

export const MinWarning = styled.p`
  font-size: 12px;
  color: #c0392b;
  margin: 8px 0 0;
`;
